export const clamp = (value, min, max) =>
  Math.min(Math.max(value, min), max);

export const sortBlogPosts = (posts) =>
  [...posts].sort(
    (left, right) => new Date(right.publishedAt) - new Date(left.publishedAt)
  );

export const getBlogPostBySlug = (posts, slug) =>
  posts.find((post) => post.slug === slug) || null;

export const formatBlogCardDate = (value) =>
  new Intl.DateTimeFormat("en-US", {
    month: "short",
    year: "numeric",
  }).format(new Date(value));

export const formatBlogPostDate = (value) =>
  new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(new Date(value));

export const calculateRevealCount = (progress, totalWords) =>
  Math.floor(clamp(progress, 0, 1) * totalWords);

export const easeOutExpo = (progress) => {
  const p = clamp(progress, 0, 1);
  return p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
};

export const getPlainTextFromBlocks = (blocks) =>
  blocks
    .map((block) =>
      block.type === "nestedList" ? block.items.join(" ") : block.text || ""
    )
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
